import React, { useState, useEffect } from 'react';
import Container from 'container';
import Headline from 'headline';
import Smoke from 'components/shared/smoke-canvas';
import Img from 'img';
import { debouncedNavigation } from '../../../utility';
import s from './bong.module.scss';
const scrollBong = (position, setPost) => {
  let pos = position;
  let topPos = window.innerWidth > 1169 ? 1100 : window.innerWidth > 375 ? 810 : window.innerWidth > 320 ? 900 : 1200;
  requestAnimationFrame(() => {
    document.querySelector(
      '.' + s.bong
    ).style.transform = `translate(0, -${pos++}px)`;
    if (pos % 100 === 0) {
      setPost(pos);
      requestAnimationFrame(() => {
        scrollBong(pos, setPost);
      });
      return;
    }
    if (pos > topPos) {
      setPost(topPos + 1);
      return;
    }
    scrollBong(pos, setPost);
  });
}

export default function Bong({
  setStage,
  handleTouchUp,
  stage,
  handleScrollEvent,
  bongPosition,
  setBongPosition
}) {
  const [startedAutoPlay, setStartedAutoPlay] = useState(false);

  const updateBongPosition = val => {
    setBongPosition(val);
  };
  (() => {
    if (stage === 9 && !startedAutoPlay) {
      if (bongPosition > 1000) {
        return;
      }
      console.log('here we are');
      scrollBong(bongPosition, updateBongPosition);
      setStartedAutoPlay(true);
    }
  })();

  return (
    <Container
      className={s.root}
      id="ritual"
      onWheel={handleScrollEvent}
      // onTouchStart={handleTouchStart}
      onTouchMove={handleTouchUp}
    >
      <div className={s.bongAnim} />
      <Img
        className={s.bong}
        src="bong1"
        width="350px"
        png
        alt="World's longest bong"
        style={{ transform: `translate(0, -${bongPosition}px)` }}
      />
      <div className={`${s.content}`}>
        <Headline h2 className={s.headline}>
          <span className={s.one}>EXIBIT</span>
          <span className={s.two}>RITUAL</span>
        </Headline>
      </div>
      <Smoke />
      {/* <Smoke style={{ transform: 'rotate(180deg)' }} /> */}
    </Container>
  );
}
